import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { makeStyles } from 'tss-react/mui';
import { Box, Typography, LinearProgress } from '@mui/material';
import formatTimeStamp from '../../../Lib/Utils/Date/format-timestamp';

const useStyles = makeStyles()((theme) => ({
  label: {
    color: get(theme, 'palette.text.main'),
  },
  boxContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  boxProgressBar: {
    width: '100%',
    mr: 1,
  },
  boxLabel: {
    minWidth: 35,
  },
}));

export default function LinearProgressWithLabel({
  progress,
  estimatedEnd = 0,
}) {
  const { classes } = useStyles();
  return (
    <Box className={classes.boxContainer}>
      <Box className={classes.boxProgressBar}>
        <LinearProgress variant="determinate" value={progress} />
      </Box>
      <Box className={classes.boxLabel}>
        <Typography variant="body2" className={classes.label}>
          {`${Math.round(
            progress,
          )}% completed -- Estimated completion in ${formatTimeStamp(
            estimatedEnd,
          )}`}
        </Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  progress: PropTypes.number.isRequired,
  estimatedEnd: PropTypes.number,
};
